
export interface ResponseData {
  [key: string]: any;
}

interface ConfigStrategy {
  execute(instanceConfig: any, appConfig: any): void;
}

const screenTypes = [
  'screen',
  'screenVideo',
  'c_thikandjuicydmv_banner',
  'c_patisseriechanson_banner',
  'c_botbarcoffee_banner',
  'c_bengongsteaus_banner',
  'c_parteanyc_banner',
  'c_kapowbuddy_banner'
];

class ScreenStrategy implements ConfigStrategy {
  execute(instanceConfig: any, appConfig: any): void {
    if (instanceConfig?.upLogoUrl && appConfig.page_indexConfig?.length) {
      const screenConfig = appConfig.page_indexConfig.find((item: any) =>
        screenTypes.includes(item?.type)
      );
      if (screenConfig) {
        appConfig.page_indexConfig.find((item: any) =>
          screenTypes.includes(item?.type)
        ).edit.backgroundImg = instanceConfig?.upLogoUrl
      }
    }
  }
}

class FormItemsStrategy implements ConfigStrategy {
  execute(instanceConfig: ResponseData, appConfig: any): void {
    if ((instanceConfig?.formItems as any[]).length > 0) {
      if (appConfig.page_indexConfig?.length) {
        const cur = appConfig.page_indexConfig.find((item: any) => item.type === "feedback")
        if (cur) {
          cur.edit.formItems = instanceConfig?.formItems;
        }
      }
    }
  }
}

const indexImageTypes = ['imageView', 'c_patisseriechanson_image', 'c_parteanyc_imageView'];

class IndexImagesStrategy implements ConfigStrategy {
  execute(instanceConfig: ResponseData, appConfig: any): void {
    if (instanceConfig?.indexImgs && Object.keys(instanceConfig?.indexImgs).length > 0) {
      if (appConfig.page_indexConfig?.length) {

        const appConfigImgs = appConfig.page_indexConfig.find?.((item: any) => indexImageTypes.includes(item?.type))?.edit.imageIndex;

        for (const key in instanceConfig?.indexImgs) {
          if ((instanceConfig?.indexImgs as any)[key] !== '' && instanceConfig?.indexImgs && appConfigImgs) {
            appConfigImgs[key] = (instanceConfig?.indexImgs as any)[key]
          }
          else if (appConfigImgs) {
            appConfigImgs[key] = ''
          }
        }
      }
    }
  }
}

class OpenTimeListStrategy implements ConfigStrategy {
  execute(instanceConfig: ResponseData, appConfig: any): void {
    if (appConfig.page_indexConfig?.length) {
      if (instanceConfig?.openTimeList && (instanceConfig?.openTimeList as any[]).length > 0) {
        const cur = appConfig.page_indexConfig.find((item: any) => item?.type === "screen");
        if (cur?.edit?.timeList) {
          cur.edit.timeList = instanceConfig?.openTimeList;
        }
      }
      else {
        const cur = appConfig.page_indexConfig.find((item: any) => item.type === "screen");
        if (cur && cur.props) {
          cur.props.isShowHours = false
        }
      }
    }
  }
}

const articleTypes = [
  'article',
  'c_patisseriechanson_article',
  'c_botbarcoffee_article',
  'c_hhtea_article',
  'c_gyuzobbq_article',
  'c_eryeteashop_article',
  'c_thehubsakakiizakayabarkaraoke_article',
  'c_kurobuta_article',
];

class ArticleStrategy implements ConfigStrategy {
  execute(instanceConfig: any, appConfig: any): void {
    const article = appConfig.page_indexConfig?.find((item: any) => articleTypes.includes(item?.type))

    if (!article) return

    if (instanceConfig?.indexBrandTitle) {
      article.edit.sign = instanceConfig?.indexBrandTitle;
    }
    if (instanceConfig?.indexBrandIntroduction) {
      if (typeof instanceConfig.indexBrandIntroduction === 'string') {
        article.edit.info_message[0] = instanceConfig.indexBrandIntroduction;
      } else {
        article.edit.info_message = instanceConfig.indexBrandIntroduction;
      }
    }
    if (instanceConfig?.centerLogoUrl) {
      article.edit.articleImg = instanceConfig?.centerLogoUrl;
    }
    article.edit.contact = instanceConfig?.supportList
  }
}

export const strategyMap: { [key: string]: ConfigStrategy } = {
  formItems: new FormItemsStrategy(),
  indexImgs: new IndexImagesStrategy(),
  openTimeList: new OpenTimeListStrategy(),
  article: new ArticleStrategy(),
  screen: new ScreenStrategy(),
  c_thikandjuicydmv_banner: new ScreenStrategy(),
}
